export default __webpack_public_path__ + "img/dHnOTUwC.0d009b60.svg";